// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__I9ZXV","title":"Header_title__3PBC5","left":"Header_left__9R7Rf","clinicName":"Header_clinicName__VYajQ"};